<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized">
    <input class="d-inline single-checkbox align-bottom mr-1" type="checkbox" [(ngModel)]="checkboxValue" (change)="onChange($event.target.checked)" />
    <label class="form-control-label d-inline"> I agree to the <a href="javascript:void(0)" (click)="onViewTerms()"> Terms and Conditions </a> 
        and acknowledge the <a href="javascript:void(0)" (click)="onViewPrivacyPolicy()"> Privacy Policy </a></label>
    
</div>
